import React from 'react'
import moment from 'moment'
import { i18n } from '../../index'
import css from './feelingMeterNotesTable.css'
type FeelingMeterNotesTableProps = {
  notes: any[]
}

const FeelingMeterNotesTable = (props: FeelingMeterNotesTableProps) => {
  const { notes } = props
  return notes.length > 0 ? (
    <div>
      <table className={css.table}>
        <thead>
          <tr>
            <th>{i18n.t('reporting.label.feelingMeterNotes.station')}</th>
            <th>{i18n.t('reporting.label.feelingMeterNotes.name')}</th>
            <th>{i18n.t('reporting.label.feelingMeterNotes.date')}</th>
            <th>{i18n.t('reporting.label.feelingMeterNotes.note')}</th>
          </tr>
        </thead>
        <tbody>
          {notes.map((note, i) => (
            <tr key={i}>
              <td>{note.station.name}</td>
              <td>{note.user.name}</td>
              <td>{moment(note.date).format('DD.MM.YYYY')}</td>
              <td>{note.note}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className={css.noNotes}>{i18n.t('reporting.label.feelingMeterNotes.noNotes')}</div>
  )
}

export default FeelingMeterNotesTable
